import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { WelcomeSection } from '../components/sections/WelcomeSection';
import { FeaturesCarousel } from '../components/sections/FeaturesCarousel';
// import { WhyChooseSection } from '../components/sections/WhyChooseSection';
import { ReviewsSection } from '../components/sections/ReviewsSection';
import { NewsSection } from '../components/sections/NewsSection';
import { ContactModal } from '../components/modals/ContactModal';
import { FamlyEnquiryLink } from '../components/sections/Contact/FamlyEnquiryLink';
import { generalMedia } from '../data/generalMedia';
import LazyVisible from '../components/Common/LazyVisible';
import { pageView } from '../firebase/analytics';

function Homepage() {
  const bg = generalMedia['hero-section'];
  pageView('/');  
  return (
    <>     
      <div className="text-black text-[17px] not-italic normal-nums font-light accent-auto bg-stone-100 bg-no-repeat box-border block tracking-[normal] leading-[30.6px] list-outside list-disc min-w-80 overflow-x-hidden overflow-y-scroll text-start indent-[0px] normal-case visible border-separate font-filson_pro after:accent-auto after:text-black after:hidden after:text-[17px] after:not-italic after:normal-nums after:font-light after:tracking-[normal] after:leading-[30.6px] after:list-outside after:list-disc after:text-start after:indent-[0px] after:normal-case after:visible after:border-separate after:font-filson_pro">
        <div className="bg-white box-border overflow-x-clip">
          <div className="relative bg-white box-border w-auto md:w-full">
            <div className="relative box-border -top-px"></div>
            <div className="box-border">
              <div className="relative box-border"></div>
              <main className="bg-white bg-no-repeat box-border clear-both px-[30px] before:accent-auto before:text-black before:table before:text-[17px] before:not-italic before:normal-nums before:font-light before:tracking-[normal] before:leading-[30.6px] before:list-outside before:list-disc before:text-start before:indent-[0px] before:normal-case before:visible before:border-separate before:font-filson_pro after:accent-auto after:clear-both after:text-black after:table after:text-[17px] after:not-italic after:normal-nums after:font-light after:tracking-[normal] after:leading-[30.6px] after:list-outside after:list-disc after:text-start after:indent-[0px] after:normal-case after:visible after:border-separate after:font-filson_pro">
                <div className="box-border flex flex-wrap max-w-full mx-auto md:block md:flex-nowrap before:accent-auto before:text-black before:table before:text-[17px] before:not-italic before:normal-nums before:font-light before:tracking-[normal] before:leading-[30.6px] before:list-outside before:list-disc before:min-h-[auto] before:min-w-[auto] before:text-start before:indent-[0px] before:normal-case before:visible before:border-separate before:font-filson_pro before:md:min-h-0 before:md:min-w-0 after:accent-auto after:clear-both after:text-black after:table after:text-[17px] after:not-italic after:normal-nums after:font-light after:tracking-[normal] after:leading-[30.6px] after:list-outside after:list-disc after:min-h-[auto] after:min-w-[auto] after:text-start after:indent-[0px] after:normal-case after:visible after:border-separate after:font-filson_pro after:md:min-h-0 after:md:min-w-0">
                  <section className="box-border float-left min-h-px min-w-[auto] w-full md:min-w-0">
                    <div className="box-border">
                      <span className="box-border hidden">Home</span>
                      <span className="box-border hidden">
                      </span>
                      <link rel="preload" as="image" href={bg.src}  />
                      <div className="relative box-border">
                        <HeroSection
                          title="Great Child"
                          subtitle="We learn through play"
                          action={
                            <FamlyEnquiryLink
                              ctaLocation="home_hero"
                              className="inline-block bg-teal-600 hover:bg-teal-700 text-white visited:text-white hover:text-white focus:text-white active:text-white no-underline hover:no-underline font-medium uppercase tracking-wide px-6 py-3 rounded-full transition"
                            >
                              Get Started
                            </FamlyEnquiryLink>
                          }
                          backgroundImage={bg.src}
                        />
                        <LazyVisible><WelcomeSection /></LazyVisible>
                        <LazyVisible><FeaturesCarousel /></LazyVisible>
                        <LazyVisible><ReviewsSection /></LazyVisible>
                        <LazyVisible><NewsSection /></LazyVisible>
                      </div>
                    </div>
                  </section>
                </div>
              </main>
            </div>
          </div>
        </div>
        <ContactModal />
      </div>
    </>
  );
}

export default Homepage;
